import { store } from 'src/state/configure-store';

import { GuardForRoute } from './guard-for-route';

export class GuardForRouteService {
  public static isProtectedRoute(guards: GuardForRoute[]): boolean {
    return !!guards && guards.some((guard) => guard.isProtected(store.getState()));
  }

  public static getRedirectUrl(guards: GuardForRoute[]): string {
    return guards.find((guard) => guard.isProtected(store.getState()))!.redirectTo;
  }
}
